import { Card, Badge } from '@yoast/ui-library';

import CardHeader from '../../components/CardHeader';
import { QueryHistoryCard } from './Card';

const QueryHistory = () => (
  <Card>
    <CardHeader title="Query history" />

    <Card className="yst-mb-4">
      <Card.Content>
        <p className="yst-mb-8">
          Manna Fish Restaurant - Analysis performed on:{' '}
          <Badge>2025-04-08 12:31:21</Badge>
        </p>

        {[0, 1, 2, 3, 4].map((val) => (
          <QueryHistoryCard key={val} />
        ))}
      </Card.Content>
    </Card>
  </Card>
);

export default QueryHistory;
